// src/auth/useSmartBack.js
//
// Hook para "navegar atrás" desde pantallas auxiliares (Paywall,
// TelegramConnect, ActivationPending, PaymentRejected, Terms, Privacy,
// Support, etc.) respetando el contexto del usuario:
//
//   1. Si hay history previo (window.history.length > 2), navigate(-1)
//      → respeta de dónde vino (típicamente dashboard, sidebar dropdown,
//      Configuración modal, etc.).
//
//   2. Si no hay history (entrada directa por URL / share / bookmark),
//      cae al destino correcto según rol/acceso:
//        - admin       → /admin/dashboard
//        - hasAccess   → /dashboard
//        - sin acceso  → / (landing pública)
//
// NO usar en pantallas de entrypoint del flow auth (Login, Signup,
// NotFound, RecoverStep*) — ahí el "atrás" debe ir a / o /login
// directamente, sin importar el contexto.
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function useSmartBack(fallback = '/') {
  const navigate = useNavigate();
  const { hasAccess, isAdmin } = useAuth();

  return () => {
    if (window.history.length > 2) {
      navigate(-1);
      return;
    }
    if (isAdmin) {
      navigate('/admin/dashboard');
    } else if (hasAccess) {
      navigate('/dashboard');
    } else {
      navigate(fallback);
    }
  };
}
